/* Gallery fix: hide duplicate images on desktop + thumbnails + slider arrows */
(function(){
  var css = '.product-media-collage.desktop-only>.product-media-collage__item:not(:first-child){display:none !important;height:0 !important;overflow:hidden !important}'
    + ' carousel-slider.thumbnails,carousel-slider.thumbnails.mobile-only,.thumbnails.mobile-only,.thumbnails,media-gallery .thumbnail-slider,media-gallery .thumbnail-list,media-gallery .thumbnails{display:none !important;height:0 !important}'
    + ' media-gallery .slider-nav,.slider-nav--floating{display:none !important}'
    + ' .product-form__input--pill,.variant-picker,.product-form__input[data-option-index]{display:none !important}'
    + ' .shopify-payment-button,.dynamic-checkout__content,[data-shopify="dynamic-checkout-cart"]{display:none !important}';
  var s = document.createElement('style');
  s.textContent = css;
  document.head.appendChild(s);
  /* Also directly hide collage items */
  document.querySelectorAll('.product-media-collage.desktop-only>.product-media-collage__item:not(:first-child)')
    .forEach(function(el){ el.style.display = 'none'; });
})();

(function() {
  var qtyLabel = document.querySelector('[data-min-qty]');
  var mq = qtyLabel ? parseInt(qtyLabel.getAttribute('data-min-qty')) : 24;
  
  var qi = document.getElementById('os-qty');
  if (!qi) return;
  
  var err = document.getElementById('os-err');
  
  var forms = document.querySelectorAll("form[action*='/cart/add']");
  
  forms.forEach(function(f) {
    if (!f.querySelector("input[name='quantity']")) {
      var hi = document.createElement('input');
      hi.type = 'hidden';
      hi.name = 'quantity';
      hi.value = mq;
      f.appendChild(hi);
    }
  });
  

  /* --- Color validation --- */
  function checkColor() {
    var colorInput = document.getElementById('cs-val');
    if (!colorInput || !colorInput.value) {
      var cerr = document.getElementById('cs-color-err');
      if (!cerr) {
        cerr = document.createElement('p');
        cerr.id = 'cs-color-err';
        cerr.style.cssText = 'color:#c00;font-size:13px;margin:4px 0 0';
        var sel = document.getElementById('cs-sel');
        if (sel) sel.parentNode.insertBefore(cerr, sel.nextSibling);
      }
      cerr.textContent = '⚠️ Please select a color';
      cerr.style.display = 'block';
      var wrap = document.getElementById('cs-wrap');
      if (wrap) wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }
    var cerr = document.getElementById('cs-color-err');
    if (cerr) cerr.style.display = 'none';
    return true;
  }

  function sync() {
    var v = parseInt(qi.value) || 0;
    if (err) {
      err.style.display = (v > 0 && v < mq) ? 'block' : 'none';
    }
    var allQ = document.querySelectorAll("input[name='quantity']");
    allQ.forEach(function(q) {
      q.value = v > 0 ? v : mq;
    });
  }
  
  qi.addEventListener('input', sync);
  qi.addEventListener('change', sync);
  
  // Intercept form submit
  forms.forEach(function(f) {
    f.addEventListener('submit', function(e) {
      if (!checkColor()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
      var v = parseInt(qi.value) || 0;
      if (v < mq) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (err) {
          err.style.display = 'block';
          err.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return false;
      }
      var allQ = document.querySelectorAll("input[name='quantity']");
      allQ.forEach(function(q) { q.value = v; });
    }, true);
  });
  
  // Intercept Add to Cart button clicks (Dawn uses fetch, not form submit)
  var buttons = document.querySelectorAll("button[name='add'], button.product-form__submit");
  buttons.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      if (!checkColor()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
      var v = parseInt(qi.value) || 0;
      if (v < mq) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (err) {
          err.style.display = 'block';
          err.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return false;
      }
      // Sync quantity before Dawn's handler runs
      var allQ = document.querySelectorAll("input[name='quantity']");
      allQ.forEach(function(q) { q.value = v; });
    }, true);
  });
  
  // Also intercept fetch to /cart/add as a safety net
  var origFetch = window.fetch;
  window.fetch = function() {
    var url = arguments[0];
    if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
      var v = parseInt(qi.value) || 0;
      if (v < mq) {
        if (err) {
          err.style.display = 'block';
          err.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return Promise.reject(new Error('Minimum quantity not met'));
      }
    }
    return origFetch.apply(this, arguments);
  };
  
  sync();
})();